import { render } from "./PlacementSelector.vue?vue&type=template&id=720603a8"
import script from "./PlacementSelector.vue?vue&type=script&lang=js"
export * from "./PlacementSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/RuleForm/PlacementSelector.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "720603a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('720603a8', __exports__)) {
    api.reload('720603a8', __exports__)
  }
  
  module.hot.accept("./PlacementSelector.vue?vue&type=template&id=720603a8", () => {
    api.rerender('720603a8', render)
  })

}


export default __exports__